import { useState, useEffect, useCallback } from "react";
import Header from "../common/header";
import CommonCard from "../common/commonCard";
import FormCard from "../common/formCard";
import { Row, Col, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import CheckBox from "../common/customCheckBox";
// import { GetComapanyService } from "../../Services/companyService";
import { GetComapanyServiceReduced } from "../../Services/companyService";
import { useParams } from "react-router-dom";
import Spinner from 'react-bootstrap/Spinner';
import { useTranslation } from "react-i18next";
import MessagePopUp from "../common/messagePopUp";
import { PostFeedbackService } from "../../Services/feedbackService";

const CreateFeedback = () => {
  const [showModal, setShowModal] = useState(false);
  const navigate = useNavigate();
  const [companyData, setCompanyData] = useState(null);
  const [loadingData, setLoadingData] = useState(false);
  const [loading, setLoading] = useState(false);

  const [t] = useTranslation("publicIncident")


  const { id } = useParams();


  const [isFormValid, setIsFormValid] = useState(false);
  const [formData, setFormData] = useState({
    feedbackType: "",
    name: "",
    title: "",
    description: "",
    acceptCheck: "",
    company: "",
  });

  const [fieldErrors, setFieldErrors] = useState({});

  //LLAMADAS API
  useEffect(() => {
    setLoadingData(true)
    const getCompany = async () => {
      try {
        const companyData = await GetComapanyServiceReduced(id);
        setCompanyData(companyData);
        setLoadingData(false)
      } catch (error) {
        console.error(error);
        setLoadingData(false)
      }
    };
    getCompany();
  }, [id]);

  useEffect(() => {

    if (companyData && !companyData.enabled) {

      const fullURL = window.location.href;
      navigate(`/access-denied`, { state: { companyData, fullURL } });

    }
  }, [companyData]);



  useEffect(() => {
    const allFieldsValid = Object.values(fieldErrors).every((error) => !error);
    setIsFormValid(allFieldsValid);
  }, [fieldErrors]);


  useEffect(() => {
    if (formData.feedbackType) {
      formData.name = '';
      validateField('name', '')
    }
  }, [formData]);

  const validateField = (field, value) => {
    let isError = false;
    let errorMessage = null;

    switch (field) {
      case "feedbackType":
        isError = value === "";
        errorMessage = isError ? `${t("createForm.error")}` : null;
        break;
      case "name":
        isError = formData.feedbackType ? false : value === "" || value.length > 100;
        errorMessage = isError ? `${t("createForm.nameError")}` : null;
        break;
      case "title":
        if (value === "") {
          isError = true;
          errorMessage = `${t("createForm.error")}`;
        } else if (value.length > 100) {
          isError = true;
          errorMessage = `${t("createForm.titleErrorLength")}`;
        }
        break;
      case "description":
        if (value === "") {
          isError = true;
          errorMessage = isError ? `${t("createForm.error")}` : null;
        } else if (value.length > 500) {
          isError = true;
          errorMessage = `${t("createForm.descriptionErrorLength")}`;
        }
        break;
      case "acceptCheck":
        isError = value === "" || value === false;
        errorMessage = isError ? `${t("createForm.error")}` : null;
        break;

      default:
        break;
    }

    setFieldErrors((prevFieldErrors) => {
      const newErrors = { ...prevFieldErrors, [field]: isError };
      newErrors[`${field}Message`] = errorMessage;
      return newErrors;
    });
    return !isError
  };


  const validateAllFields = () => {

    const { feedbackType, acceptCheck, name, title, description } = formData;

    const isFeedbackTypeValid = validateField("feedbackType", feedbackType);

    const isAcceptCheckValid = validateField("acceptCheck", acceptCheck);

    const isNameValid = !feedbackType ? validateField("name", name) : true;

    const isTitleValid = validateField("title", title);

    const isDescriptionValid = validateField("description", description);

    return isFeedbackTypeValid && isAcceptCheckValid && isNameValid && isTitleValid && isDescriptionValid;
  }



  const handleCancelClick = () => {
    navigate(`/public/${id}`); // Navega a la página /createIncident
  };

  const handleFieldChange = (field, value) => {
    setFormData((prevFormData) => {
      const updatedFormData = { ...prevFormData, [field]: value };
      validateField(field, value); // Validar el campo cuando se actualiza
      return updatedFormData;
    });
  };

  const handleSaveClick = async (e) => {
    setLoading(true)
    e.preventDefault();
    if (validateAllFields()) {
      formData.company = id;

      const response = await PostFeedbackService(formData);
      setShowModal(true)
      setLoading(false)
    }
    setLoading(false)
  };

  const handleContinueClick = (e) => {
    e.preventDefault(); // Anula el comportamiento predeterminado de envío del formulario.
    navigate(`/public/${id}`);
  };



  return (
    <>
      <MessagePopUp
        show={showModal}
        buttonText={'CONTINUAR'}
        handleClose={handleContinueClick}
        title={'SUGERENCIA CREADA'}
        onClickButton={handleContinueClick}
        textBody={'La sugerencia ha sido enviada'}
      />

      <div>
        <Header privateWeb={true} publicIncident={true} imageMimeType={companyData && companyData.imageMimeType}
          imageData={companyData && companyData.imageData} />
        <div style={{ width: "90%", margin: "0 auto" }}>
          <CommonCard title={t("createFeedback.title")} icon={'FaEnvelope'}>
            {loadingData ?
              <div className="create-incident-loading-container">
                <div className="public-card-loading-row ">
                  <div className="public-card-loading-popup custom-shadow-bold rounded-border-px">
                    <Spinner animation="border" className="spinner-bigger" />
                  </div>
                </div>
              </div>
              :
              <>
                <Row>
                  <Col md={6}>
                    <FormCard
                      title={t("createForm.feedbackType")}
                      type={"select"}
                      readOnly={false}
                      error={fieldErrors.feedbackType}
                      errorMessage={fieldErrors.feedbackTypeMessage}
                      onChange={(e) => handleFieldChange("feedbackType", e.value)}
                      options={[
                        { label: "---", value: "" },
                        { label: `${t("createForm.anonymous")}`, value: true },
                        { label: `${t("createForm.confidential")}`, value: false },
                      ]}
                    />
                  </Col>
                  <Col md={6}>
                    {!formData.feedbackType ?
                      <FormCard
                        key={0}
                        title={t("createForm.name")}
                        type={"text"}
                        readOnly={formData.feedbackType ? true : false}
                        error={fieldErrors.name}
                        errorMessage={fieldErrors.nameMessage}
                        onChange={(e) => handleFieldChange("name", e.target.value)}
                      />
                      :
                      <FormCard
                        key={1}
                        title={t("createForm.name")}
                        type={"text"}
                        readOnly={formData.feedbackType ? true : false}
                      />

                    }
                  </Col>
                </Row>
                <Row>
                  <Col md={12}>
                    {formData.feedbackType !== "" ? (
                      <div>
                        <CheckBox
                          text={
                            formData.feedbackType
                              ? `${t("createForm.acceptCheckAnonymousFeedback")}`
                              : !formData.feedbackType
                                ? `${t("createForm.acceptCheckConfidentialFeedback")}`
                                : ""
                          }
                          error={fieldErrors.acceptCheck}
                          errorMessage={fieldErrors.acceptCheckMessage}
                          onChange={(e) => handleFieldChange("acceptCheck", e)}
                          bigCheck
                        />
                      </div>
                    ) : null}
                  </Col>
                </Row>
                <Row>

                  <Col md={6}>
                    <FormCard
                      title={t("createForm.title")}
                      type={"text"}
                      readOnly={false}
                      error={fieldErrors.title}
                      errorMessage={fieldErrors.titleMessage}
                      onChange={(e) => handleFieldChange("title", e.target.value)}
                    />
                  </Col>
                  <Col md={6}>
                    <FormCard
                      title={t("createForm.description")}
                      type={"textarea"}
                      readOnly={false}
                      error={fieldErrors.description}
                      errorMessage={fieldErrors.descriptionMessage}
                      onChange={(e) => handleFieldChange("description", e.target.value)}
                    />
                  </Col>

                </Row>

                <div className="d-flex justify-content-around mt-4">
                  <Button variant="secondary" className="custom-button-secondary" onClick={handleCancelClick}>
                    {t("createForm.cancel")}
                  </Button>
                  <Button
                    variant="success"
                    className="custom-button-primary"
                    onClick={handleSaveClick}
                    disabled={!isFormValid || loading}
                  >
                    {loading ?
                      <>
                        <Spinner animation="border" className="spinner me-4" />
                        {t("createForm.saving")}
                      </>
                      :
                      `${t("createForm.save")}`
                    }
                  </Button>
                </div>
              </>
            }



          </CommonCard>
        </div>
      </div>

    </>
  );
};

export default CreateFeedback;
